import * as React from "react";

import dayjs from "dayjs";
import { useUserContext } from "../../user-provider";
import { useUtilityContext } from "../../utility-provider";
import { LOCAL_CONSTANT } from "../Const";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { getAccessToken, getPlanAreaInfo, staffName } from "../Common";
import { getLongPageData } from "../../data/DataManage";
import { getFileMetadata } from "../../utility/storage";
import ApprovalSurveyModal from "../subPage/ApprovalSurvey/ApprovalSurveyModal";
import {
    Box,
    Typography,
    Button,
    Grid,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DownloadIcon from "@mui/icons-material/Download";
import {
    setAddSurveyObj,
    setObjCover,
} from "../../features/locationAddSurveySlice";
import { addSurveyData, showUploadDate } from "../components/LocationAddSurveyFunc";
import { commonFileDownload } from "../Common";
import { coverData } from "../subPage/Cover/CoverFunction";
import PdfViewer from "../../utility/PdfViewer";
import PdfViewerModal from "../../utility/PdfViewerModal";
import { handlePdfPreviewScreenOpen } from "../../utility/PdfViewerModal";
import { encryptQueryParam, decryptQueryParam } from '../../utility/util';
import {
    setAdditionalResearchCoverPdf,
    setAdditionalResearchCoverConfirmedPdf,
    setAdditionalResearchPdf,
    setAdditionalResearchMergePdf,
} from "../../features/additionalResearchSlice";

const headerCell = (type: string) => {
    return{
        backgroundColor: '#D9D9D9',
        fontSize: '12px',
        color: 'black',
        borderBottom: '1px solid black',
        fontWeight: 'Bold',
        width: type === 'FILE_NAME' ? '40%'
        : type === 'UPLOAD_DATE' ? '15%' 
        : type === 'UPLOADER' ? '15%'
        : '6%',
        textAlign: type === 'OTHER' ? 'center' : 'start'
    }
};
const rowCell = {
    border: "none",
};

//理由書金額のラベル
const amount_stated_labels = [
    { header: "初年度", Name: "forecast_value_1" },
    { header: "2年度", Name: "forecast_value_2" },
    { header: "3年度", Name: "forecast_value_3" },
];

//参照値算出結果のラベル
const reference_value_labels = [
    { header: "初年度", Name: "reference_value_1" },
    { header: "2年度", Name: "reference_value_2" },
    { header: "3年度", Name: "reference_value_3" },
    { header: "4年度", Name: "reference_value_4" },
    { header: "5年度", Name: "reference_value_5" },
];

interface resultProps {
    props: {};
}
const ApprovalSurvey: React.FC<resultProps> = ({ props }) => {
    const user = useUserContext();
    const dispatch = useAppDispatch();
    const utilityCtx = useUtilityContext();
    const [windowSize, setWindowSize] = React.useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    //追加調査を取得
    const objLocationAddSurvey = useAppSelector(
        (state) => state.locationAddSurvey.obj
    );
    //URLパラメータ
    const [planAreaId, setPlanAreaId] = React.useState("");
    const [branch, setBranch] = React.useState("");

    const [approvalModalOpen, setApprovalModalOpen] =
        React.useState<boolean>(false);
    const [userData, setUserData] = React.useState<any>({});
    const [approvalMgrStamp, setApprovalMgrStamp] = React.useState<string>("");
    const [approvalGmStamp, setApprovalGmStamp] = React.useState<string>("");
    const [approvalResearchMgrStamp, setApprovalResearchMgrStamp] =
        React.useState<string>("");
    const [approvalResearchGmStamp, setApprovalResearchGmStamp] =
        React.useState<string>("");
    const [approvalReferenceStaffStamp, setApprovalReferenceStaffStamp] =
        React.useState<string>("");
    const [
        approvalReferenceResearchMgrStamp,
        setApprovalReferenceResearchMgrStamp,
    ] = React.useState<string>("");
    const [
        approvalReferenceResearchGmStamp,
        setApprovalReferenceResearchGmStamp,
    ] = React.useState<string>("");
    const [
        approvalReferenceResearchGmFlag,
        setApprovalReferenceResearchGmFlag,
    ] = React.useState<boolean>(false);
    const [coverPdfPath, setCoverPdfPath] = React.useState<any>({});
    const [coverConfirmPdfPath, setCoverConfirmPdfPath] = React.useState<any>(
        {}
    );
    const [mergePdfPath, setMergePdfPath] = React.useState<any[]>([]);

    const [receptionBook, setReceptionBook] = React.useState<any>([]);
    const [planAreaInfoData, setPlanAreaInfoData] = React.useState<any>();
    const objStorePlanAreaId = useAppSelector(
        (state) => state.longPage.storePlanAreaId
    );
    //モーダル開閉フラグ(PDFプレビュー)
    const [pdfPreviewModalFlag, setPdfPreviewModalFlag] = React.useState(false);
    const [pdfModalPath, setPdfModalPath] = React.useState<string>("");

    //プレビュー
    const previewPdfPath = useAppSelector(
        (state) => state.additionalResearch.coverPdfPath
    );
    const previewConfirmedPdfPath = useAppSelector(
        (state) => state.additionalResearch.coverConfirmedPdfPath
    );
    const previewDocumentPdfPath = useAppSelector(
        (state) => state.additionalResearch.pdfPath
    );
    const previewMergePdfPath = useAppSelector(
        (state) => state.additionalResearch.mergePdfPath
    );

    const handleValueChange = (path: any, labelName: string) => {
        if (
            previewPdfPath === path?.fullPath ||
            previewConfirmedPdfPath === path?.fullPath ||
            previewDocumentPdfPath === `${planAreaId}/${branch}${path.file_path}` ||
            previewMergePdfPath === `${planAreaId}/${branch}${path}` ||
            path === ""
        ) {
            if (labelName === "previewPdfPath") {
                dispatch(setAdditionalResearchCoverPdf(""));
            } else if (labelName === "previewConfirmPdfPath") {
                dispatch(setAdditionalResearchCoverConfirmedPdf(""));
            } else if (labelName === "previewDocumentPdfPath") {
                dispatch(setAdditionalResearchPdf(""));
            } else if (labelName === "previewMergePdfPath") {
                dispatch(setAdditionalResearchMergePdf(""));
            }
        } else {
            if (labelName === "previewPdfPath") {
                dispatch(setAdditionalResearchCoverPdf(path.fullPath));
            } else if (labelName === "previewConfirmPdfPath") {
                dispatch(setAdditionalResearchCoverConfirmedPdf(path.fullPath));
            } else if (labelName === "previewDocumentPdfPath") {
                dispatch(
                    setAdditionalResearchPdf(
                        `${planAreaId}/${branch}${path.file_path}`
                    )
                );
            } else if (labelName === "previewMergePdfPath") {
                dispatch(setAdditionalResearchMergePdf(`${planAreaId}/${branch}${path}`));
            }
        }
    };
    const [difference, setDifference] = React.useState<number>(0);
    //理由書金額のテキストフィールド
    const [addSurveyForecastValue, setAddSurveyForecastValue] = 
        React.useState<any>({
            forecast_value_1: "",
            forecast_value_2: "",
            forecast_value_3: "",
        });

    //参照値算出結果のテキストフィールド
    const [addSurveyReferenceValue, setAddSurveyReferenceValue] =
        React.useState<any>({
            reference_value_1: "",
            reference_value_2: "",
            reference_value_3: "",
            reference_value_4: "",
            reference_value_5: "",
        });

    React.useEffect(() => {
        //暗号化されたクエリパラメータを復号化
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            setPlanAreaId(res[0]);
            setBranch(res[1]);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
        function handleResize() {
            // ヘッダーの分を引く
            const tempHeight = window.innerHeight - 48;
            // ハンバーガーメニューの分を引く
            const tempWidth = window.innerWidth - 56;
            setWindowSize({ width: tempWidth, height: tempHeight });
        }

        // 初回ロード時のサイズに基づいてスケーリング
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    React.useEffect(() => {
        if(planAreaId !== "" && branch !== ""){
            loadApi();
        }
    }, [planAreaId, branch]);

    React.useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserData(JSON.parse(user.userData));
        }
    }, [user]);


    const loadApi = async () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        callApi()
            .then((res: any) => {
                const addSurveyDataResult = addSurveyData(res.getLocationAddSurvey);
                
                // Reduxに保存
                dispatch(setAddSurveyObj(addSurveyDataResult));
                
                // 追加調査一式ファイル処理
                if (addSurveyDataResult.merge_file_path) {
                    const parsedPath = typeof addSurveyDataResult.merge_file_path === "string"
                        ? JSON.parse(addSurveyDataResult.merge_file_path)  // JSON文字列をパース
                        : addSurveyDataResult.merge_file_path;              // すでにオブジェクト
                    // タイムスタンプで降順ソート（新しい順）
                    const sortedFiles = [...parsedPath].sort((a, b) => 
                        new Date(b.upload_date).getTime() - new Date(a.upload_date).getTime()
                    );
                    setMergePdfPath(sortedFiles);
                }
                
                // 画像
                const bucket_path = `${process.env.REACT_APP_GOOGLE_STORAGE}/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${planAreaId}/${branch}`;
                const access_token = getAccessToken();

                if (
                    res.getLocationAddSurvey[0].approval_research_mgr_stamp !==
                    ""
                ) {
                    setApprovalResearchMgrStamp(
                        `${bucket_path}${res.getLocationAddSurvey[0].approval_research_mgr_stamp}${access_token}`
                    );
                }
                if (
                    res.getLocationAddSurvey[0].approval_research_gm_stamp !==
                    ""
                ) {
                    setApprovalResearchGmStamp(
                        `${bucket_path}${res.getLocationAddSurvey[0].approval_research_gm_stamp}${access_token}`
                    );
                }
                if (res.getLocationAddSurvey[0].approval_mgr_stamp !== "") {
                    setApprovalMgrStamp(
                        `${bucket_path}${res.getLocationAddSurvey[0].approval_mgr_stamp}${access_token}`
                    );
                }
                if (res.getLocationAddSurvey[0].approval_gm_stamp !== "") {
                    setApprovalGmStamp(
                        `${bucket_path}${res.getLocationAddSurvey[0].approval_gm_stamp}${access_token}`
                    );
                }
                if (
                    res.getLocationAddSurvey[0]
                        .approval_reference_staff_stamp !== ""
                ) {
                    setApprovalReferenceStaffStamp(
                        `${bucket_path}${res.getLocationAddSurvey[0].approval_reference_staff_stamp}${access_token}`
                    );
                }
                if (
                    res.getLocationAddSurvey[0]
                        .approval_reference_research_mgr_stamp !== ""
                ) {
                    setApprovalReferenceResearchMgrStamp(
                        `${bucket_path}${res.getLocationAddSurvey[0].approval_reference_research_mgr_stamp}${access_token}`
                    );
                }
                if (
                    res.getLocationAddSurvey[0]
                        .approval_reference_research_gm_stamp !== "" &&
                    res.getLocationAddSurvey[0]
                        .approval_reference_research_gm_flag === "1"
                ) {
                    setApprovalReferenceResearchGmStamp(
                        `${bucket_path}${res.getLocationAddSurvey[0].approval_reference_research_gm_stamp}${access_token}`
                    );
                    setApprovalReferenceResearchGmFlag(true);
                }
                setReceptionBook(res.getReceptionBookByIdAndBranch[0]);
                // 表紙
                dispatch(setObjCover(coverData(res.getLocationCover)));
                getPlanAreaInfo(planAreaId, objStorePlanAreaId).then((data) => {
                    setPlanAreaInfoData(data);
                });
            })
            .catch((e) => {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            })
            .finally(() => {
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            });
    };

    const callApi = async () => {
        const param: any = [];

        param.push({
            mode: "getLocationAddSurvey",
            plan_area_id: planAreaId,
            branch: branch,
        });
        param.push({
            mode: "getReceptionBookByIdAndBranch",
            plan_area_id: planAreaId,
            branch: branch,
        });
        param.push({
            mode: "getLocationCover",
            plan_area_id: planAreaId,
            branch: branch,
        });

        return await getLongPageData(param);
    };

    const openApprovalModal = () => {
        setApprovalModalOpen(true);
    };

    const closeApprovalModal = () => {
        setApprovalModalOpen(false);
    };

    React.useEffect(() => {
        (async () => {
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner();
            }
            try {
                if (objLocationAddSurvey.cover_pdf_path) {
                    await getFileMetadata(
                        `/${planAreaId}/${branch}${objLocationAddSurvey.cover_pdf_path}`
                    ).then((result) => {
                        setCoverPdfPath(result);
                    });
                }
                if (objLocationAddSurvey.cover_confirm_pdf_path) {
                    await getFileMetadata(
                        `/${planAreaId}/${branch}${objLocationAddSurvey.cover_confirm_pdf_path}`
                    ).then((result) => {
                        setCoverConfirmPdfPath(result);
                    });
                }
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }, [objLocationAddSurvey.cover_excel_user]);

    React.useEffect(() => {
        //ReduxをuseStateに保存
        setAddSurveyReferenceValue({
            ...objLocationAddSurvey,
            reference_value_1: objLocationAddSurvey.reference_value_1,
            reference_value_2: objLocationAddSurvey.reference_value_2,
            reference_value_3: objLocationAddSurvey.reference_value_3,
            reference_value_4: objLocationAddSurvey.reference_value_4,
            reference_value_5: objLocationAddSurvey.reference_value_5,
        });
        setAddSurveyForecastValue({
            ...objLocationAddSurvey,
            forecast_value_1: objLocationAddSurvey.forecast_value_1,
            forecast_value_2: objLocationAddSurvey.forecast_value_2,
            forecast_value_3: objLocationAddSurvey.forecast_value_3,
        });
        //差分比較
        setDifference(parseInt(objLocationAddSurvey.reference_value_1) - parseInt(objLocationAddSurvey.forecast_value_1));
        const bucket_path = `${process.env.REACT_APP_GOOGLE_STORAGE}/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${planAreaId}/${branch}`;
        const access_token = getAccessToken();

        if (objLocationAddSurvey.approval_research_mgr_stamp !== "") {
            setApprovalResearchMgrStamp(
                `${bucket_path}${objLocationAddSurvey.approval_research_mgr_stamp}${access_token}`
            );
        }
        if (objLocationAddSurvey.approval_research_gm_stamp !== "") {
            setApprovalResearchGmStamp(
                `${bucket_path}${objLocationAddSurvey.approval_research_gm_stamp}${access_token}`
            );
        }
        if (objLocationAddSurvey.approval_mgr_stamp !== "") {
            setApprovalMgrStamp(
                `${bucket_path}${objLocationAddSurvey.approval_mgr_stamp}${access_token}`
            );
        }
        if (objLocationAddSurvey.approval_gm_stamp !== "") {
            setApprovalGmStamp(
                `${bucket_path}${objLocationAddSurvey.approval_gm_stamp}${access_token}`
            );
        }
        if (objLocationAddSurvey.approval_reference_staff_stamp !== "") {
            setApprovalReferenceStaffStamp(
                `${bucket_path}${objLocationAddSurvey.approval_reference_staff_stamp}${access_token}`
            );
        }
        if (objLocationAddSurvey.approval_reference_research_mgr_stamp !== "") {
            setApprovalReferenceResearchMgrStamp(
                `${bucket_path}${objLocationAddSurvey.approval_reference_research_mgr_stamp}${access_token}`
            );
        }
        if (objLocationAddSurvey.approval_reference_research_gm_stamp !== "" &&
            objLocationAddSurvey.approval_reference_research_gm_flag === "1") {
            setApprovalReferenceResearchGmStamp(
                `${bucket_path}${objLocationAddSurvey.approval_reference_research_gm_stamp}${access_token}`
            );
            setApprovalReferenceResearchGmFlag(true);
        }
    }, [objLocationAddSurvey]);

    const gotoLocation = () => {
        // 別タブで開く
        const baseUrl = window.location.origin;
        const param = `planAreaId=${planAreaId}&branch=${branch}`;
        encryptQueryParam(param).then((res) => {
            const fullPath = `${baseUrl}/LongPage?` + res;
            window.open(fullPath);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    //PDFプレビューモーダルオープン
    const handlePdfPreviewModalOpen = (pdfPathParam: string) => {
        setPdfPreviewModalFlag(true);
        setPdfModalPath(pdfPathParam);
    };

    // ファイルDL
    const fileDownload = (data: any, target: string) => {
        let fullPath = `/${data.fullPath}`;
        let fileName = `/${data.name}`;
        if (target === "descriptionDocument") {
            fullPath = `/${planAreaId}/${branch}${data.file_path}`;
            fileName = data.file_path.substring(5);
        }
        commonFileDownload(fullPath, fileName);
    };

    const showTimeCreated = (data: any) => {
        let timeCreated = "";
        if ("name" in data) {
            timeCreated = dayjs(data?.timeCreated).format(
                "YYYY/MM/DD HH:mm:ss"
            );
        }

        return timeCreated;
    };

    const disabledApproval = () => {
        // 承認/差戻の活性、非活性
        // 活性がfalse、非活性がtrue
        
        // RRの場合
        if (LOCAL_CONSTANT.RR_DEPARTMENT.includes(userData.department_code_OA)) {
            // RRMgrの活性化条件
            // E010(Mgr承認待ち Mgr 参考値承認)：職種がMgrかつ所属がリクルートリサーチの時
            // E011(Mgr承認待ち Mgr 確定値承認)：職種がMgrかつ所属がリクルートリサーチの時
            // E012(Mgr承認待ち Mgr 参考値差戻確認)：職種がMgrかつ所属がリクルートリサーチの時
            // E013(Mgr承認待ち Mgr 確定値差戻確認)：職種がMgrかつ所属がリクルートリサーチの時
            if (["230"].includes(userData.job_category_code_OA)) {
                if (["E010", "E011", "E012", "E013"].includes(receptionBook?.task_id)) {
                    return false;
                } else {
                    return true;
                }
            // RRGMの活性化条件
            // E014(RR GM承認待ち RR GM 参考値承認)：職種がAGMまたはGM、かつ所属がリクルートリサーチの時
            // E015(RR GM承認待ち RR GM 確定値承認)：職種がAGMまたはGM、かつ所属がリクルートリサーチの時
            } else if (["101", "102"].includes(userData.job_category_code_OA)) {
                if (["E014", "E015"].includes(receptionBook?.task_id)) {
                    return false;
                } else {
                    return true;
                }
            // 職種がMgr,AGM,GM以外はボタン非活性化
            } else {
                return true;
            }
        } else {
            // RR以外の場合
            // departmentMasterにあるdepartment_code_oaかdistrict_code_oaに該当するかチェック
            const departmentMasterObj = localStorage.getItem("departmentMaster");
            let isValidDepartment = false;
            
            if (departmentMasterObj !== null && departmentMasterObj !== "undefined") {
                const jsonDepartmentMasterObj = JSON.parse(departmentMasterObj);
                isValidDepartment = jsonDepartmentMasterObj.some((dept: any) => 
                    dept.department_code_oa === userData.department_code_OA || 
                    dept.district_code_oa === userData.department_code_OA
                );
            }
            
            if (isValidDepartment) {
                // 現場RMの活性化条件
                // E001(RM承認待ち RM 参考値承認)：職種がMgrかつ所属がリクルートリサーチ以外の時
                // E002(RM承認待ち RM 確定値承認)：職種がMgrかつ所属がリクルートリサーチ以外の時
                if (userData.job_category_code_OA === "230") {
                    if (["E001", "E002"].includes(receptionBook?.task_id)) {
                        return false;
                    } else {
                        return true;
                    }
                // 現場GMの活性化条件
                // E003(GM承認待ち GM 確定値承認)：職種がAGMまたはGM、かつ所属がリクルートリサーチ以外の時
                } else if (["101", "102"].includes(userData.job_category_code_OA)) {
                    if (["E003"].includes(receptionBook?.task_id)) {
                        return false;
                    } else {
                        return true;
                    }
                // 職種がMgr,AGM,GM以外はボタン非活性化
                } else {
                    return true;
                }
            } else {
                // departmentMasterに該当しない場合は非活性
                return true;
            }
        }
    };

    return (
        <Box
            sx={{
                width: windowSize.width + 56,
                height: windowSize.height + 56,
                overflowY: "scroll",
            }}
        >
            <Box sx={{ width: "100%" }}>
                <Box sx={{ padding: "70px 0 20px 40px" }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "end",
                            marginRight: "30px",
                        }}
                    >
                        <Button
                            variant="contained"
                            color="success"
                            size="small"
                            sx={{ padding: "10px 20px" }}
                            onClick={gotoLocation}
                        >
                            調査書
                        </Button>
                    </Box>
                    <Box>
                        <h3>追加調査</h3>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                            sx={{
                                margin: "42px 0 0 0",
                                alignSelf: "flex-start",
                                whiteSpace: "nowrap",
                                fontWeight: "bold",
                            }}
                            >
                                理由書金額
                        </Typography>
                        <Box sx={{ display: "flex", margin: "0 62px" }}>
                            {amount_stated_labels.map((label, index) => (
                                <Box key={index} sx={{minWidth: "150px", maxWidth: "150px"}}>
                                    <Typography
                                        align="center"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {label.header}
                                    </Typography>
                                    <TextField
                                        value={
                                            addSurveyForecastValue[label.Name]
                                        }
                                        disabled={true}
                                        inputProps={{
                                            sx: {
                                                width: "100%",
                                                textAlign: "center",
                                            },
                                        }}
                                    />
                                </Box>
                            ))}
                            <Box
                                sx={{
                                    display: "flex",
                                    margin: "0px 50px"
                                }}
                            >
                                <Typography
                                    align="center"
                                    sx={{ 
                                        margin: "42px 0 0 0",
                                        alignSelf: "flex-start",
                                        whiteSpace: "nowrap",
                                        fontWeight: "bold",
                                        color: difference >= 0 ? "blue":"red"
                                    }}
                                >
                                    {difference >= 0 ? "到達":"未達"}
                                </Typography>
                                {difference < 0 && (
                                    <Typography
                                        align="center"
                                        sx={{ 
                                            margin: "42px 10px",
                                            alignSelf: "flex-start",
                                            whiteSpace: "nowrap",
                                            fontWeight: "bold", 
                                            color: "red"
                                        }}
                                    >
                                        {String(difference) + "(千円)"}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                            sx={{
                                marginRight: "20px",
                                marginTop: "60px",
                                alignSelf: "flex-start",
                                whiteSpace: "nowrap",
                                fontWeight: "bold",
                            }}
                        >
                            参考値算出結果
                        </Typography>
                        <Box sx={{ display: "flex", margin: "0 10px" }}>
                            {reference_value_labels.map((label, index) => (
                                <Box key={index} sx={{minWidth: "150px", maxWidth: "150px"}}>
                                    <Typography
                                        align="center"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {label.header}
                                    </Typography>
                                    <TextField
                                        value={
                                            addSurveyReferenceValue[label.Name]
                                        }
                                        inputProps={{
                                            sx: {
                                                textAlign: "center",
                                                backgroundColor: "#FFFCD6",
                                            },
                                        }}
                                        disabled={true}
                                    />
                                </Box>
                            ))}
                        </Box>
                        <Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    担当者
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リサーチ Mgr
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                        display: approvalReferenceResearchGmFlag ? "block":"none"
                                    }}
                                >
                                    リサーチ GM
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img
                                        src={approvalReferenceStaffStamp}
                                    ></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img
                                        src={approvalReferenceResearchMgrStamp}
                                    ></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                        display: approvalReferenceResearchGmFlag ? "block":"none"
                                    }}
                                >
                                    <img
                                        src={approvalReferenceResearchGmStamp}
                                    ></img>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* 追加調査一式表示 */}
                    <Box sx={{ margin: "20px 0" }}>
                        <Box>
                            <h5>追加調査一式</h5>
                        </Box>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                                <TableContainer sx={{
                                    width: "100%",
                                    border: "1px solid black",
                                }}>
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                                <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                                <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                                <TableCell sx={headerCell("OTHER")}></TableCell>
                                                <TableCell sx={headerCell("OTHER")}></TableCell>
                                                <TableCell sx={headerCell("OTHER")}>PDF</TableCell>
                                                <TableCell sx={headerCell("OTHER")}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {mergePdfPath && mergePdfPath.length > 0 && 
                                                mergePdfPath.map((val, index) => {
                                                    // 最新ファイルは通常表示、それ以外はグレーアウト
                                                    const isLatest = index === 0;
                                                    const displayLabel = val.file_name.replace(".pdf", "");
                                                    return (
                                                        <TableRow 
                                                            className="tableRow" 
                                                            key={index}
                                                            sx={{ backgroundColor: isLatest ? "#fff" : "#D9D9D9" }}
                                                        >
                                                            <TableCell 
                                                                onClick={() => handleValueChange(val.pdf_path, "previewMergePdfPath")}
                                                            >
                                                                {displayLabel}
                                                            </TableCell>
                                                            <TableCell 
                                                                onClick={() => handleValueChange(val.pdf_path, "previewMergePdfPath")}
                                                            >
                                                                {showUploadDate(val.upload_date)}
                                                            </TableCell>
                                                            <TableCell 
                                                                onClick={() => handleValueChange(val.pdf_path, "previewMergePdfPath")}
                                                            >
                                                                {staffName(val.upload_user_id)}
                                                            </TableCell>
                                                            <TableCell sx={{ textAlign: "center" }}>
                                                                {val.pdf_path !== "" && (
                                                                    <IconButton
                                                                        sx={{ color: "black" }}
                                                                        onClick={(e) => {
                                                                            handlePdfPreviewModalOpen(
                                                                                `${planAreaId}/${branch}${val.pdf_path}`
                                                                            )
                                                                        }}
                                                                    >
                                                                        <PictureAsPdfIcon />
                                                                    </IconButton>
                                                                )}
                                                            </TableCell>
                                                            <TableCell sx={{ textAlign: "center" }}>
                                                                {val.pdf_path !== "" && (
                                                                    <IconButton
                                                                        sx={{ color: "black" }}
                                                                        onClick={() => {
                                                                            handlePdfPreviewScreenOpen(
                                                                                `${planAreaId}/${branch}${val.pdf_path}`
                                                                            )
                                                                        }}
                                                                    >
                                                                        <OpenInNewIcon />
                                                                    </IconButton>
                                                                )}
                                                            </TableCell>
                                                            <TableCell sx={{ textAlign: "center" }}>
                                                                {val.pdf_path !== "" && (
                                                                    <IconButton
                                                                        sx={{ color: "black" }}
                                                                        onClick={(e) => {
                                                                            commonFileDownload(`${planAreaId}/${branch}${val.pdf_path}`, displayLabel);
                                                                        }}
                                                                    >
                                                                        <DownloadIcon />
                                                                    </IconButton>
                                                                )}
                                                            </TableCell>
                                                            <TableCell></TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                        {/* PDFプレビュー */}
                        {previewMergePdfPath !== "" && (
                            <Box sx={{ padding: "30px 40px 0px 0px" }}>
                                <PdfViewer props={{ pdfPath: previewMergePdfPath }} />
                            </Box>
                        )}
                    </Box>
                    <Box>
                        <h5>表紙（参考値）</h5>
                    </Box>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer
                                sx={{
                                    height: "132px",
                                    width: "100%",
                                    border: "1px solid black",
                                }}
                            >
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                            <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                            <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}>PDF</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() => handleValueChange(coverPdfPath, "previewPdfPath")}
                                            >
                                                {coverPdfPath?.name}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() => handleValueChange(coverPdfPath, "previewPdfPath")}
                                            >
                                                {showTimeCreated(coverPdfPath)}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() => handleValueChange(coverPdfPath, "previewPdfPath")}
                                            >
                                                {staffName(objLocationAddSurvey.cover_excel_user)}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center", border: "none", }}>
                                                {objLocationAddSurvey.cover_pdf_path !== "" && (
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={(e) => {
                                                            handlePdfPreviewModalOpen(coverPdfPath?.fullPath)
                                                        }}
                                                    >
                                                        <PictureAsPdfIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center", border: "none", }}>
                                                {objLocationAddSurvey.cover_pdf_path !== "" && (
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={() => {
                                                            handlePdfPreviewScreenOpen(coverPdfPath?.fullPath)
                                                        }}
                                                    >
                                                        <OpenInNewIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center", border: "none", }}>
                                                {objLocationAddSurvey.cover_pdf_path !== "" && (
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={() =>
                                                            fileDownload(coverPdfPath, "cover")
                                                        }
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                            <TableCell sx={rowCell}></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    {previewPdfPath !== "" && (
                        <Box sx={{ paddingTop: "30px", width: "98%" }}>
                            <PdfViewer props={{ pdfPath: previewPdfPath }} />
                        </Box>
                    )}
                    <Box sx={{ display: "flex", margin: "20px 0" }}>
                        <h5>表紙（確定値）</h5>
                        <Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リサーチ Mgr
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リサーチ GM
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リクルート Mgr
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リクルート GM
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img src={approvalResearchMgrStamp}></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img src={approvalResearchGmStamp}></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img src={approvalMgrStamp}></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img src={approvalGmStamp}></img>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer
                                sx={{
                                    height: "132px",
                                    width: "100%",
                                    border: "1px solid black",
                                }}
                            >
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                            <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                            <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}>PDF</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() => handleValueChange(coverConfirmPdfPath, "previewConfirmPdfPath")}
                                            >
                                                {coverConfirmPdfPath?.name}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() => handleValueChange(coverConfirmPdfPath, "previewConfirmPdfPath")}
                                            >
                                                {showTimeCreated(coverConfirmPdfPath)}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() => handleValueChange(coverConfirmPdfPath, "previewConfirmPdfPath")}
                                            >
                                                {staffName(objLocationAddSurvey.cover_confirm_excel_user)}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center", border: "none", }}>
                                                {objLocationAddSurvey.cover_confirm_pdf_path !== "" && (
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={(e) => {
                                                            handlePdfPreviewModalOpen(coverConfirmPdfPath?.fullPath)
                                                        }}
                                                    >
                                                        <PictureAsPdfIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center", border: "none", }}>
                                                {objLocationAddSurvey.cover_confirm_pdf_path !== "" && (
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={() => {
                                                            handlePdfPreviewScreenOpen(coverConfirmPdfPath?.fullPath)
                                                        }}
                                                    >
                                                        <OpenInNewIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center", border: "none", }}>
                                                {objLocationAddSurvey.cover_confirm_pdf_path !== "" && (
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={() =>
                                                            fileDownload(coverConfirmPdfPath, "cover")
                                                        }
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                            <TableCell sx={rowCell}></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    {previewConfirmedPdfPath !== "" && (
                        <Box sx={{ paddingTop: "30px", width: "98%" }}>
                            <PdfViewer
                                props={{ pdfPath: previewConfirmedPdfPath }}
                            />
                        </Box>
                    )}
                    <Box>
                        <h5>説明資料</h5>
                    </Box>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer
                                sx={{
                                    height: "424px",
                                    width: "100%",
                                    border: "1px solid black",
                                }}
                            >
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                            <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                            <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}>PDF</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {objLocationAddSurvey.doc_pdf_path?.map(
                                            (data: any, index: any) => (
                                                <TableRow
                                                    className="tableRow"
                                                    key={index}
                                                    sx={{
                                                        backgroundColor: data.isExcluded ? "#B0B0B0" : "inherit", // 対象外にチェックがある場合、背景をグレー
                                                    }}
                                                >
                                                    <TableCell
                                                        onClick={() => handleValueChange(data, "previewDocumentPdfPath")}
                                                    >
                                                        {data.file_name}
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() => handleValueChange(data, "previewDocumentPdfPath")}
                                                    >
                                                        {data.upload_date}
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() => handleValueChange(data, "previewDocumentPdfPath")}
                                                    >
                                                        {staffName(data.upload_staff_number)}
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: "center" }}>
                                                        {data.file_path !== "" && (
                                                            <IconButton
                                                                sx={{ color: "black" }}
                                                                onClick={(e) => {
                                                                    handlePdfPreviewModalOpen(
                                                                        `${planAreaId}/${branch}${data.file_path}`
                                                                    )
                                                                }}
                                                            >
                                                                <PictureAsPdfIcon />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: "center" }}>
                                                        {data.file_path  !== "" && (
                                                            <IconButton
                                                                sx={{ color: "black" }}
                                                                onClick={() => {
                                                                    handlePdfPreviewScreenOpen(
                                                                        `${planAreaId}/${branch}${data.file_path}`
                                                                    )
                                                                }}
                                                            >
                                                                <OpenInNewIcon />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: "center" }}>
                                                        {data.file_path  !== "" && (
                                                            <IconButton
                                                                sx={{ color: "black" }}
                                                                onClick={() =>
                                                                    fileDownload(data, "descriptionDocument")
                                                                }
                                                            >
                                                                <DownloadIcon />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            )
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    {/* PDFプレビュー */}
                    {previewDocumentPdfPath !== "" && (
                        <Box sx={{ paddingTop: "30px", width: "98%" }}>
                            <PdfViewer
                                props={{
                                    pdfPath: previewDocumentPdfPath,
                                }}
                            />
                        </Box>
                    )}
                    {/* PDFプレビューモーダル */}
                    <PdfViewerModal
                        props={{
                            open: pdfPreviewModalFlag,
                            setOpen: setPdfPreviewModalFlag,
                            pdfPath: pdfModalPath,
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        position: "fixed",
                        bottom: "50px",
                        right: "50px",
                        zIndex: 1000,
                    }}
                >
                    <Button
                        variant="contained"
                        color="success"
                        size="small"
                        sx={{ padding: "10px 20px" }}
                        disabled={disabledApproval()}
                        onClick={openApprovalModal}
                    >
                        承認/差戻
                    </Button>
                </Box>
                <ApprovalSurveyModal
                    props={{
                        open: approvalModalOpen,
                        handleModal: closeApprovalModal,
                        planAreaId: planAreaId,
                        branch: branch,
                        userData: userData,
                        receptionBook: receptionBook,
                        planAreaInfoData: planAreaInfoData,
                    }}
                />
            </Box>
        </Box>
    );
};

export default ApprovalSurvey;
